import { Tooltip } from "primereact/tooltip";

import commonStyle from "../content/CommonStyles.module.css";

const ProductStatusCircle = ({ id, type, isActive }) => {
    return (
        <div className="flex justify-content-center align-content-center">
            {isActive ? (
                <div
                    className={`${commonStyle[type]} ${commonStyle.active}`}
                    data-pr-tooltip="Активний"
                    data-pr-position="top"
                    id={`statusCircle-${id}`}
                ></div>
            ) : (
                <div
                    className={`${commonStyle[type]} ${commonStyle.inactive}`}
                    data-pr-tooltip="Деактивований"
                    data-pr-position="top"
                    id={`statusCircle-${id}`}
                ></div>
            )}
            <Tooltip target={`#statusCircle-${id}`} />
        </div>
    );
}

export default ProductStatusCircle;